module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navbar', {
    attrs: {
      "fixed": "",
      "back": "",
      "bg": ""
    }
  }, [_c('span', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('scroller', {
    ref: "scroller"
  }, [_c('div', {
    staticClass: "content-padded"
  }, [_c('div', {
    staticClass: "inner",
    staticStyle: {
      "z-index": "20"
    }
  }, [_c('h1', {
    staticClass: "characteristic-title"
  }, [_vm._v("申请条件")]), _vm._v(" "), _c('div', {
    staticClass: "characteristic-txt"
  }, _vm._l((_vm.apply), function(item, index) {
    return _c('p', {
      key: index
    }, [_c('span', [_vm._v(_vm._s(item.title))]), _vm._v("："), _c('span', [_vm._v(_vm._s(item.content))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "inner",
    staticStyle: {
      "z-index": "10"
    }
  }, [_c('h1', {
    staticClass: "inner-title"
  }, [_c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v(" 适用人群")]), _vm._v(" "), _c('ul', {
    staticClass: "counter-list"
  }, _vm._l((_vm.application), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "item"
    }, [_c('span', [_vm._v(_vm._s(item.title))]), _vm._v("："), _c('span', [_vm._v(_vm._s(item.content))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "inner",
    staticStyle: {
      "z-index": "0"
    }
  }, [_c('h1', {
    staticClass: "inner-title"
  }, [_c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v(" 所需材料")]), _vm._v(" "), _c('ul', {
    staticClass: "counter-list"
  }, _vm._l((_vm.material), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "item"
    }, [_vm._v(_vm._s(item.content))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "wrap-btn"
  }, [_c('button', {
    staticClass: "apply-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.doOrder
    }
  }, [_vm._v("立即申请")])])])], 1), _vm._v(" "), _c('spinner', {
    attrs: {
      "show": _vm.loading
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f5d3fd20!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/borrow/detail.vue
// module id = 382
// module chunks = 1